// Public endpoints use either a direct list or the existing { list } envelope.
// A successful null list is empty; an error envelope must never become cached content.
export function readPublicMusicList(response) {
  if (response?.code !== 200) throw new Error('Public music unavailable');
  const data = response.data;
  if (data === null) return [];
  const list = Array.isArray(data) ? data : data?.list;
  if (list === null) return [];
  if (!Array.isArray(list)) throw new Error('Invalid public music response');
  return list;
}
